export default {
  props: {
    propertyTriggers: {
      type: Object,
      required: false,
      default: () => new Object
    }
  },
  methods: {
    emitPropertyEvents(value) {
      if (! Object.prototype.hasOwnProperty.call(this.propertyTriggers, value)) {
        return
      }
      this.$store.dispatch('eventModule/emit', this.propertyTriggers[value])
    },
  }
}